// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.back {
    background: linear-gradient(45deg, #05006a 35%, #16167c 40%, #00d4ff 90%);
    min-width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.back2 {
    background: linear-gradient(45deg, #02002a 60%, #0d0d54 70%, rgb(8, 0, 255) 90%);
    min-width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.page {
    background-color: rgba(0, 0, 0, 0.4);
    /* Capa de blanco con 60% de opacidad */
    min-width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.showProfile {
    display: block;
    background-color: #007BFF;
    color: #fff;
    padding: 2vmin 4vmin;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    position: fixed;
    top: 0;
    left: 12%;
    margin: 1%;
    margin-right: 98%;
    border-radius: 10%;
    min-width: 4vmin;
}

.showProfile:hover {
    background-color: #73b6fd;
    transform: scale(1.1);
}


.fun {
    text-align: center;
    background-color: #fff;
    /* Color de fondo de la tarjeta */
    border: none;
    border-radius: 10px;
    /* Bordes redondeados */
    width: 80%;
    padding: 20px;
    box-shadow: 3px 3px 4px silver;
    /* Sombra de la tarjeta */
    font-size: 2rem;
    color: #212529;
    /* Color de texto inicial */
    cursor: pointer;
    transition: transform 0.2s ease-in-out, color 0.3s ease-in-out;
    /* Añadido color a la transición */
}

.fun:hover {
    transform: scale(1.1);
    /* Aumenta el tamaño */
    color: #FF4500;
    /* Cambia el color del texto a naranja oscuro */
}



.logo-container img {
    position: fixed;
    top: 0;
    left: 2vmin;
    margin: 1%;
    margin-left: 1%;
    border-radius: 10%;
    max-width: 0.5vmin;
    min-width: 0.5vmin;

}

.profile_container img {
    position: fixed;
    top: 0;
    left: 12vmin;
    margin: 1%;
    margin-left: 3%;
    border-radius: 10%;
    max-width: 0.5vmin;
    min-width: 0.5vmin;
}

.foot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    color: #fff;
    text-align: center;
    padding: 1vmin;
    font-size: 1.5vmin;
}

/*
*
*   SOCIAL MEDIA
*
*/

.socialparent {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.socialchild {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform-style: preserve-3d;
    transition: all 0.5s ease-in-out;
    border-radius: 50%;
    margin: 0 5px;
}

.socialchild:hover {
    background-color: rgb(195, 195, 195);
    background-position: -100px 100px, -100px 100px;
    transform: rotate3d(0.5, 1, 0, 30deg);
    transform: perspective(180px) rotateX(60deg) translateY(2px);
    box-shadow: 0px 10px 10px rgb(1, 49, 182);
}

.socialbutton {
    border: none;
    background-color: transparent;
    font-size: 20px;
}

.socialbutton:hover {
    width: inherit;
    height: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translate3d(0px, 0px, 15px) perspective(180px) rotateX(-35deg) translateY(2px);
    border-radius: 50%;
}

.fun_bot,
.fun_bot::after {
    text-align: center;
    background-color: rgba(245, 241, 241, 0.4);
    /* Color de fondo de la tarjeta */
    /* Bordes redondeados */
    width: 80%;
    padding: 20px;
    box-shadow: 3px 3px 4px silver;
    /* Sombra de la tarjeta */
    font-size: 2rem;
    color: #212529;
    /* Color de texto inicial */
    cursor: pointer;
    padding: 20px 50px;
    font-size: 20px;
    border: none;
    border-radius: 5px;
    position: relative;
}

.fun_bot::after {
    --move1: inset(50% 50% 50% 50%);
    --move2: inset(31% 0 40% 0);
    --move3: inset(39% 0 15% 0);
    --move4: inset(45% 0 40% 0);
    --move5: inset(45% 0 6% 0);
    --move6: inset(14% 0 61% 0);
    clip-path: var(--move1);
    content: 'BDP_ESP';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
}

.fun_bot:hover::after {
    animation: glitch_4011 1s;
    text-shadow: 10 10px 10px black;
    animation-timing-function: steps(2, end);
    text-shadow: -3px -3px 0px #1df2f0, 3px 3px 0px #E94BE8;
    background-color: transparent;
    border: 3px solid rgb(0, 255, 213);
}

.fun_bot:hover {
    text-shadow: -1px -1px 0px #1df2f0, 1px 1px 0px #E94BE8;
    background-color: #ffffff55;
    border: 1px solid rgb(0, 255, 213);
    box-shadow: 3px 3px 4px rgb(0, 255, 213);
}

@keyframes glitch_4011 {
    0% {
        clip-path: var(--move1);
        transform: translate(0px, -10px);
    }

    10% {
        clip-path: var(--move2);
        transform: translate(-10px, 10px);
    }

    20% {
        clip-path: var(--move3);
        transform: translate(10px, 0px);
    }

    30% {
        clip-path: var(--move4);
        transform: translate(-10px, 10px);
    }

    40% {
        clip-path: var(--move5);
        transform: translate(10px, -10px);
    }

    50% {
        clip-path: var(--move6);
        transform: translate(-10px, 10px);
    }

    60% {
        clip-path: var(--move1);
        transform: translate(10px, -10px);
    }

    70% {
        clip-path: var(--move3);
        transform: translate(-10px, 10px);
    }

    80% {
        clip-path: var(--move2);
        transform: translate(10px, -10px);
    }

    90% {
        clip-path: var(--move4);
        transform: translate(-10px, 10px);
    }

    100% {
        clip-path: var(--move1);
        transform: translate(0);
    }
}


`, "",{"version":3,"sources":["webpack://./src/components/mainPage/main.css"],"names":[],"mappings":"AAAA;IACI,yEAAyE;IACzE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gFAAgF;IAChF,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,MAAM;IACN,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,8DAA8D;IAC9D,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,+CAA+C;AACnD;;;;AAIA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,+CAA+C;IAC/C,qCAAqC;IACrC,4DAA4D;IAC5D,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yFAAyF;IACzF,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,0CAA0C;IAC1C,iCAAiC;IAGjC,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,wCAAwC;IACxC,uDAAuD;IACvD,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,uDAAuD;IAIvD,2BAA2B;IAC3B,kCAAkC;IAClC,wCAAwC;AAL5C;;AAQA;IACI;QACI,uBAAuB;QACvB,gCAAgC;IACpC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;IAC3B;AACJ","sourcesContent":[".back {\n    background: linear-gradient(45deg, #05006a 35%, #16167c 40%, #00d4ff 90%);\n    min-width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.back2 {\n    background: linear-gradient(45deg, #02002a 60%, #0d0d54 70%, rgb(8, 0, 255) 90%);\n    min-width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.page {\n    background-color: rgba(0, 0, 0, 0.4);\n    /* Capa de blanco con 60% de opacidad */\n    min-width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.showProfile {\n    display: block;\n    background-color: #007BFF;\n    color: #fff;\n    padding: 2vmin 4vmin;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    position: fixed;\n    top: 0;\n    left: 12%;\n    margin: 1%;\n    margin-right: 98%;\n    border-radius: 10%;\n    min-width: 4vmin;\n}\n\n.showProfile:hover {\n    background-color: #73b6fd;\n    transform: scale(1.1);\n}\n\n\n.fun {\n    text-align: center;\n    background-color: #fff;\n    /* Color de fondo de la tarjeta */\n    border: none;\n    border-radius: 10px;\n    /* Bordes redondeados */\n    width: 80%;\n    padding: 20px;\n    box-shadow: 3px 3px 4px silver;\n    /* Sombra de la tarjeta */\n    font-size: 2rem;\n    color: #212529;\n    /* Color de texto inicial */\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out, color 0.3s ease-in-out;\n    /* Añadido color a la transición */\n}\n\n.fun:hover {\n    transform: scale(1.1);\n    /* Aumenta el tamaño */\n    color: #FF4500;\n    /* Cambia el color del texto a naranja oscuro */\n}\n\n\n\n.logo-container img {\n    position: fixed;\n    top: 0;\n    left: 2vmin;\n    margin: 1%;\n    margin-left: 1%;\n    border-radius: 10%;\n    max-width: 0.5vmin;\n    min-width: 0.5vmin;\n\n}\n\n.profile_container img {\n    position: fixed;\n    top: 0;\n    left: 12vmin;\n    margin: 1%;\n    margin-left: 3%;\n    border-radius: 10%;\n    max-width: 0.5vmin;\n    min-width: 0.5vmin;\n}\n\n.foot {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: #000;\n    color: #fff;\n    text-align: center;\n    padding: 1vmin;\n    font-size: 1.5vmin;\n}\n\n/*\n*\n*   SOCIAL MEDIA\n*\n*/\n\n.socialparent {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.socialchild {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transform-style: preserve-3d;\n    transition: all 0.5s ease-in-out;\n    border-radius: 50%;\n    margin: 0 5px;\n}\n\n.socialchild:hover {\n    background-color: rgb(195, 195, 195);\n    background-position: -100px 100px, -100px 100px;\n    transform: rotate3d(0.5, 1, 0, 30deg);\n    transform: perspective(180px) rotateX(60deg) translateY(2px);\n    box-shadow: 0px 10px 10px rgb(1, 49, 182);\n}\n\n.socialbutton {\n    border: none;\n    background-color: transparent;\n    font-size: 20px;\n}\n\n.socialbutton:hover {\n    width: inherit;\n    height: inherit;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transform: translate3d(0px, 0px, 15px) perspective(180px) rotateX(-35deg) translateY(2px);\n    border-radius: 50%;\n}\n\n.fun_bot,\n.fun_bot::after {\n    text-align: center;\n    background-color: rgba(245, 241, 241, 0.4);\n    /* Color de fondo de la tarjeta */\n    border: none;\n    border-radius: 10px;\n    /* Bordes redondeados */\n    width: 80%;\n    padding: 20px;\n    box-shadow: 3px 3px 4px silver;\n    /* Sombra de la tarjeta */\n    font-size: 2rem;\n    color: #212529;\n    /* Color de texto inicial */\n    cursor: pointer;\n    padding: 20px 50px;\n    font-size: 20px;\n    border: none;\n    border-radius: 5px;\n    position: relative;\n}\n\n.fun_bot::after {\n    --move1: inset(50% 50% 50% 50%);\n    --move2: inset(31% 0 40% 0);\n    --move3: inset(39% 0 15% 0);\n    --move4: inset(45% 0 40% 0);\n    --move5: inset(45% 0 6% 0);\n    --move6: inset(14% 0 61% 0);\n    clip-path: var(--move1);\n    content: 'BDP_ESP';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: block;\n}\n\n.fun_bot:hover::after {\n    animation: glitch_4011 1s;\n    text-shadow: 10 10px 10px black;\n    animation-timing-function: steps(2, end);\n    text-shadow: -3px -3px 0px #1df2f0, 3px 3px 0px #E94BE8;\n    background-color: transparent;\n    border: 3px solid rgb(0, 255, 213);\n}\n\n.fun_bot:hover {\n    text-shadow: -1px -1px 0px #1df2f0, 1px 1px 0px #E94BE8;\n}\n\n.fun_bot:hover {\n    background-color: #ffffff55;\n    border: 1px solid rgb(0, 255, 213);\n    box-shadow: 3px 3px 4px rgb(0, 255, 213);\n}\n\n@keyframes glitch_4011 {\n    0% {\n        clip-path: var(--move1);\n        transform: translate(0px, -10px);\n    }\n\n    10% {\n        clip-path: var(--move2);\n        transform: translate(-10px, 10px);\n    }\n\n    20% {\n        clip-path: var(--move3);\n        transform: translate(10px, 0px);\n    }\n\n    30% {\n        clip-path: var(--move4);\n        transform: translate(-10px, 10px);\n    }\n\n    40% {\n        clip-path: var(--move5);\n        transform: translate(10px, -10px);\n    }\n\n    50% {\n        clip-path: var(--move6);\n        transform: translate(-10px, 10px);\n    }\n\n    60% {\n        clip-path: var(--move1);\n        transform: translate(10px, -10px);\n    }\n\n    70% {\n        clip-path: var(--move3);\n        transform: translate(-10px, 10px);\n    }\n\n    80% {\n        clip-path: var(--move2);\n        transform: translate(10px, -10px);\n    }\n\n    90% {\n        clip-path: var(--move4);\n        transform: translate(-10px, 10px);\n    }\n\n    100% {\n        clip-path: var(--move1);\n        transform: translate(0);\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
